import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { UntypedFormGroup, UntypedFormControl, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { faPlus, faTrash, faArrowLeft, faArrowRight, faCog, faFilter, faSearch, faArrowsAlt, faBars } from '@fortawesome/free-solid-svg-icons';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { TableColumn as CommonTableColumn } from 'src/app/components/common/common-table/common-table.component';
import { TableColumn as NgxTableColumn, DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject, of, debounceTime, distinctUntilChanged, tap, switchMap, TimeoutError, merge } from 'rxjs';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';
import { DropdownOption } from 'src/app/components/common/common-dropdown/common-dropdown.component.model';
import { ItemSearchOptionField, ItemSearchOptionFieldOption } from 'src/app/components/filter-list/models/filterClasses';
import { ConditionSource, ConditionTarget, ConditionOperator, OperatorTypes, ConditionValue } from 'src/app/components/system/condition-builder/condition-builder.model';
import { ModalConfirmComponent } from 'src/app/components/system/modal-confirm/modal-confirm.component';
import { Workflow, WorkflowType } from 'src/app/models';
import { DataSetField, WorkflowFilter, FilterConfig, ReportDataSetFieldDataType } from 'src/app/models/custom-report';
import { DateDataEntity, FreeFormTextDataEntity } from 'src/app/models/data-entities';
import { FilterBuilderParam, FilterBuilderFilter } from 'src/app/models/filter-builder';
import { WorkflowApplicationReportDataSet, DataSet, AggregatedDataSetFieldTypes, AggregatedDataSetRowTypes, ReportDataSetOrder, DataSetAggregateRow, DataSetAggregrateGroupingRow, DataSetAggregateGroupedCriteriaRow, DataSetAggregateField, DataSetAggregateCalculatedField, DataSetAggregateKeyField, DataSetAggregateStaticField, AggregatedDataSet, SortDirection } from 'src/app/models/report-data-set';
import { ReportDataSetFieldMapping } from 'src/app/models/report-data-set-field-mapping';
import { Utilities, WorkflowService, WorkflowContextService, SecurityService } from 'src/app/services';
import { ReportService } from 'src/app/services/report.service';
import { svgs } from 'src/assets/export.assets';
import { DatasetAddWorkflowsComponent } from './dataset-add-workflows/dataset-add-workflows.component';

@Component({
  selector: 'app-new-dataset',
  templateUrl: './new-dataset.component.html',
  styleUrls: ['./new-dataset.component.scss'],
  standalone: false
})
export class NewDatasetComponent implements OnInit, OnDestroy {

  @Input() dataSetId?: string;
  @Input() dataSetName?: string;
  @Input() showNewDatasetControls: boolean = true;
  @Input() showDataSetInformation: boolean = true;
  @Input() showFilterInputConfiguration: boolean = true;
  @Input() showSortingConfiguration: boolean = true;
  @Input() staticFilters?: ItemSearchOptionField[];
  @Input() getAvailableWorkflows?: () => Observable<Workflow[]>;
  @Input() staticFields?: DataSetField[];
  @Output() dataSetSaved = new EventEmitter<string>();

  availbleWorkflows: Workflow[];
  dataSet: WorkflowApplicationReportDataSet;
  ds: DataSet;
  columns: NgxTableColumn[];
  rows: any[];
  workflowEntities: { [key: string]: string[] };
  resultColumns: CommonTableColumn[];
  resultRows: any[];
  aggregatedResultRows: { [key: string]: any[] };
  aggregatedResultColumns: { [key: string]: CommonTableColumn[] };
  lastMappingWorkflowId: string;

  workflowIdx: { [key: string]: Workflow };
  // added by Vipul on 09-03-2026
  columnOptions: DropdownOption[] = [];
  // end by Vipul on 09-03-2026

  @ViewChild('workflow', { static: true }) workflowColumnTmpl: TemplateRef<any>;
  @ViewChild('workflowFooter', { static: false })
  workflowColumnFooterTmpl: TemplateRef<any>;
  @ViewChild('cell', { static: true }) columnTmpl: TemplateRef<any>;
  @ViewChild('columnHeader', { static: true }) columnHeaderTmpl: TemplateRef<
    any
  >;
  @ViewChild('dsGrid', { static: false }) dsGrid: DatatableComponent;
  @ViewChild('columnActions', { static: true }) columnActions: ElementRef<
    HTMLElement
  >;
  @ViewChild('fieldSettings', { static: true })
  fieldSettings: ModalConfirmComponent;
  @ViewChild('workflowStaticFilter', { static: true })
  workflowStaticFilter: ModalConfirmComponent;
  @ViewChild('filterInputConfig', { static: true })
  filterInputConfig: ModalConfirmComponent;
  @ViewChild('selectWorkflowWarning', { static: true })
  selectWorkflowWarning: ModalConfirmComponent
  @ViewChild('mappingConfig', { static: true })
  mappingConfig: ModalConfirmComponent;
  @ViewChild('aggSets', { static: false })
  aggSets: NgbNav;
  @ViewChild('datasetAddWorkflows', { static: false })
  datasetAddWorkflows: DatasetAddWorkflowsComponent;
  @ViewChild('datasetOverlayZone', { static: false })
  datasetOverlayZone: ElementRef<HTMLElement>;
  @ViewChildren(MatMenuTrigger) sortingMenuTriggers: QueryList<MatMenuTrigger>;
  private readonly capturedScrollHandler = (): void => {
    this.sortingMenuTriggers?.forEach(trigger => trigger.closeMenu());
  };
  form: UntypedFormGroup;
  filterInputForm: UntypedFormGroup;
  fieldSettingsForm: UntypedFormGroup;
  mappingForm: UntypedFormGroup;

  @ViewChild('groupingRow', { static: false })
  groupingRow: TemplateRef<any>;
  @ViewChild('groupingCriteriaRow', { static: false })
  groupingCriteriaRow: TemplateRef<any>;
  @ViewChild('staticField', { static: false })
  staticField: TemplateRef<any>;
  @ViewChild('keyField', { static: false })
  keyField: TemplateRef<any>;
  @ViewChild('calculatedField', { static: false })
  calculatedField: TemplateRef<any>;

  faPlus = faPlus;
  faTrash = faTrash;
  faArrowLeft = faArrowLeft;
  faArrowRight = faArrowRight;
  faCog = faCog;
  faFilter = faFilter;
  faSearch = faSearch;
  faArrowsAlt = faArrowsAlt;
  faBars = faBars;

  ColumnMode = ColumnMode;

  hoverColumn: NgxTableColumn;
  actionColumn: NgxTableColumn;
  actionField: DataSetField;
  hoveringOnAction = false;
  hoverLeft = 0;
  workflowFilterConfig: WorkflowFilter;
  workflowFilterParams: FilterBuilderParam[];
  workflowFilters: FilterBuilderFilter[];
  filterTypes = [];
  filterInputField: DataSetField;
  activeMapping: ReportDataSetFieldMapping;
  allowFiltering = false;
  executingTest = false;
  columnHideId: any;
  fieldSettingsTitle: string;
  ALL_WORKFLOWS_ID = Utilities.EMPTY_GUID; // 'DAD0A740-C081-44DD-B8FC-08D1B7FB79F7'; // static generated GUID because there was a workflow with EMPTY GUID in DEV.
  canPublish = false;
  previousSystemFields: DataSetField[];
  hasPreviousSystemData: boolean;

  focus$ = new Subject<string>();
  searching: boolean;
  isDeveloper: boolean;
  outputFormulaConditionSources: ConditionSource[];
  isSystemAdmin: boolean;

  aggKeys: string[];

  workflowFilterIndex: { [key: string]: WorkflowFilter };

  newGroupingField: string;
  AggregatedDataSetFieldTypes = AggregatedDataSetFieldTypes;
  AggregatedDataSetRowTypes = AggregatedDataSetRowTypes;
  conditionSources: ConditionSource[];
  filters: { [key: string]: any[] };
  isColumnSettingsOpen = false;
  selectedColumnSettingsWorkflowId: string | null = null;
  selectedColumnSettingsField: any | null = null;
  columnSettingsTopOffsetPx = 0;

  // added by Vipul on 09-03-2026
  deleteFilter(row: any) {
    this.ds.filterConfig.fields =
      this.ds.filterConfig.fields.filter(
        f => f.name !== row.name
      );
  }

  saveFilter(event: any) {
    const { filter, index } = event;
    if (!this.ds.filterConfig) {
      this.ds.filterConfig = new FilterConfig({ fields: [] });
    }
    const normalizedFilter = this.normalizeFilterField(filter);
    if (index > -1) {
      this.ds.filterConfig.fields = this.ds.filterConfig.fields.map((f, i) =>
        i === index ? normalizedFilter : f
      );
    } else {
      this.ds.filterConfig.fields = [
        ...this.ds.filterConfig.fields,
        normalizedFilter
      ];
    }
  }

  onSaveFilterInput(filter: any) {
    if (!this.ds.filterConfig) {
      this.ds.filterConfig = new FilterConfig({ fields: [] });
    }
    const normalizedFilter = this.normalizeFilterField(filter);
    const existing = this.ds.filterConfig.fields.find(
      f => f.name === normalizedFilter.name
    );
    if (!existing) {
      this.ds.filterConfig.fields.push(normalizedFilter);
    } else {
      const idx = this.ds.filterConfig.fields.indexOf(existing);
      this.ds.filterConfig.fields[idx] = normalizedFilter;
    }
  }
  // end by Vipul on 09-03-2026

  get aggResultKeys() {
    if (this.aggregatedResultRows) {
      return Object.keys(this.aggregatedResultRows);
    }
    return null;
  }

  get aggregateRowTypes(): { key: string; value: string }[] {
    return [
      { key: AggregatedDataSetRowTypes.groupingRow, value: 'Grouping Row' },
      {
        key: AggregatedDataSetRowTypes.groupingCriteriaRow,
        value: 'Grouping Filtered Row'
      }
    ];
  }

  get aggregateFieldTypes(): { key: string; value: string }[] {
    return [
      {
        key: AggregatedDataSetFieldTypes.groupKeyField,
        value: 'Grouping Key Field'
      },
      {
        key: AggregatedDataSetFieldTypes.calculatedField,
        value: 'Calculated Field'
      },
      { key: AggregatedDataSetFieldTypes.staticField, value: 'Static Field' }
    ];
  }

  constructor(
    private _workflowSvc: WorkflowService,
    private _reportSvc: ReportService,
    public _context: WorkflowContextService,
    private _route: ActivatedRoute,
    private _toastr: ToastrService,
    private _router: Router,
    private _ref: ChangeDetectorRef,
    private _securitySvc: SecurityService
  ) { }

  ngOnInit() {
    // Added by Amisha on 09/25/2026. Reason: capture non-bubbling scroll events
    // from the reports container so open sorting menus close reliably.
    document.addEventListener('scroll', this.capturedScrollHandler, true);
    // Added by Amisha on 09/25/2026. Reason: close Material menus on wheel and
    // touch movement before nested reports containers move beneath them.
    document.addEventListener('wheel', this.capturedScrollHandler, true);
    document.addEventListener('touchmove', this.capturedScrollHandler, true);
    this.hasPreviousSystemData = this._context.hasPreviousSystemData;
    this.form = new UntypedFormGroup({
      fieldOrder: new UntypedFormGroup({}),
      workflows: new UntypedFormGroup({}),
      dataSetName: new UntypedFormControl('', Validators.required),
      dataSetDesc: new UntypedFormControl('', Validators.nullValidator),
      dataSetType: new UntypedFormControl('', Validators.nullValidator),
      dataSetOutput: new UntypedFormControl('', Validators.nullValidator)
    });

    this.filterInputForm = new UntypedFormGroup({
      field: new UntypedFormControl('', Validators.required),
      label: new UntypedFormControl('', Validators.nullValidator),
      isRequired: new UntypedFormControl('', Validators.nullValidator),
      searchField: new UntypedFormControl('', Validators.nullValidator)
    });

    this.fieldSettingsForm = new UntypedFormGroup({
      fieldName: new UntypedFormControl('', Validators.required),
      fieldHeader: new UntypedFormControl('', Validators.required),
      fieldDataType: new UntypedFormControl('', Validators.required),
      fieldIsParcelNumber: new UntypedFormControl('', Validators.nullValidator),
      fieldIsPermitNumber: new UntypedFormControl('', Validators.nullValidator),
      fieldOutputFormula: new UntypedFormControl('', Validators.nullValidator),
      fieldConditionalOutput: new UntypedFormControl(
        '',
        Validators.nullValidator
      )
    });

    this.mappingForm = new UntypedFormGroup({
      columnEntity: new UntypedFormControl('', Validators.required)
    });

    this._securitySvc.isDeveloper().subscribe(result => {
      this.isDeveloper = result;
    });

    this._securitySvc.isSystemAdministrator().subscribe(result => {
      this.isSystemAdmin = result;
    });

    // Use provided workflow getter function if available, otherwise fetch from service
    const workflowSource = this.getAvailableWorkflows
      ? this.getAvailableWorkflows()
      : this._workflowSvc.getWorkflows(this._context.client, false, false, [
        WorkflowType.ContractorRegistration,
        WorkflowType.Renewable,
        WorkflowType.ContractorRenewal,
        WorkflowType.Permit,
        WorkflowType.Other,
        WorkflowType.MobileInspection
      ]);

    workflowSource.subscribe(workflows => {
      this.workflowIdx = {};

      workflows.forEach(w => {
        this.workflowIdx[w.id] = w;
      });
      if (this.hasPreviousSystemData) {
        this.workflowIdx[this._context.previousSystemDataWorkflowId] = null;
      }
      this.availbleWorkflows = workflows;
    });

    this._route.params.subscribe(parms => {
      // Added by Amisha on 04/24/2026: also honor navigation-state dataset ids so department publish can open the reports editor prefilled, while using the non-deprecated Router API.
      const navigationStateDataSetId =
        this._router.currentNavigation()?.extras?.state?.['dataSetId'] ||
        history.state?.dataSetId;
      const dataSetId: string = this.dataSetId || parms.dataSetId || navigationStateDataSetId;

      Observable.create(o => {
        if (dataSetId === Utilities.EMPTY_GUID || !dataSetId) {
          const ds = new DataSet();
          ds.dataSetConfig = new WorkflowApplicationReportDataSet();
          ds.clientId = this._context.client.id;
          ds.dataSetConfig.clientIds = [this._context.client.id];
          o.next(ds);
        } else {
          this._workflowSvc.getDataSet(dataSetId).subscribe(ds => {
            o.next(ds);
          });
        }
      }).subscribe(ds => {
        this.workflowEntities = {};

        if (!ds.filterConfig) {
          ds.filterConfig = new FilterConfig({ fields: [] });
        }

        this.allowFiltering = (ds.filterConfig.fields || []).length > 0;

        this.ds = ds;
        this.dataSet = ds.dataSetConfig;

        // Apply dataSetName input if provided for new datasets
        if (this.dataSetName && !ds.id) {
          this.ds.name = this.dataSetName;
        }

        // Set the form control value from either the loaded dataset or the input
        if (ds.name) {
          this.form.controls['dataSetName'].setValue(ds.name);
        } else if (this.dataSetName) {
          this.form.controls['dataSetName'].setValue(this.dataSetName);
        }

        if (ds.description) {
          this.form.controls['dataSetDesc'].setValue(ds.description);
        }

        if (this.ds.dataSetConfig?.type) {
          this.form.controls['dataSetType'].setValue(this.ds.dataSetConfig.type);
        }

        if (this.ds.dataSetConfig?.outputDataSet) {
          this.form.controls['dataSetOutput'].setValue(
            this.ds.dataSetConfig.outputDataSet
          );
        }

        // If staticFilterInput were loaded from the backend and we don't have input filters, use the saved ones
        if (ds.filterConfig && ds.filterConfig.staticFilterInput && ds.filterConfig.staticFilterInput.length > 0 && (!this.staticFilters || this.staticFilters.length === 0)) {
          // Convert flat ItemSearchOptionFieldOption[] back to ItemSearchOptionField[] structure if needed
          const groupedFilters: { [key: string]: ItemSearchOptionField } = {};
          ds.filterConfig.staticFilterInput.forEach(option => {
            if (!groupedFilters[option.title]) {
              groupedFilters[option.title] = {
                title: option.title,
                options: []
              };
            }
            groupedFilters[option.title].options.push(option);
          });
          this.staticFilters = Object.values(groupedFilters);
        }

        // remove any columns that don't have a name (bad data)
        this.dataSet.fields = this.dataSet.fields.filter(f => f.name);

        // Add static fields if provided by parent component
        if (this.staticFields && this.staticFields.length > 0) {
          // Add static fields that don't already exist in the dataset
          this.staticFields.forEach(staticField => {
            const existingField = this.dataSet.fields.find(f => f.name === staticField.name);
            if (!existingField) {
              this.dataSet.fields.push(staticField);
            }
          });
        }

        // create an initial sort row when a default field exists, but let the
        // user choose the direction explicitly from the UI
        if (ds.dataSetConfig.fieldOrder.length === 0) {
          // Check if there are non-static fields in the static fields collection
          const nonStaticField = this.staticFields?.find(f => f.isStatic === false);

          if (nonStaticField) {
            // Add a sort order based on the first non-static field
            (<UntypedFormGroup>this.form.controls['fieldOrder']).addControl(
              'field0',
              new UntypedFormControl(nonStaticField.name, Validators.required)
            );
            (<UntypedFormGroup>this.form.controls['fieldOrder']).addControl(
              'order0',
              new UntypedFormControl('', Validators.required)
            );

            this.dataSet.fieldOrder.push(
              new ReportDataSetOrder({
                ordinal: 0,
                fieldName: nonStaticField.name
              })
            );

            this.buildSortOrderUI();
          } else {
            this.addSortOrder();
          }
        } else {
          this.buildSortOrderUI();

          if (this.dataSet.workflowIds.length > 0) {
            const workflowGroup: UntypedFormGroup = <UntypedFormGroup>(
              this.form.controls['workflows']
            );
            this.dataSet.workflowIds.forEach((id, idx) => {
              workflowGroup.addControl(
                idx.toString(),
                new UntypedFormControl(id, Validators.required)
              );
            });
            this.workflowFilterIndex = {};
            this.dataSet.workflowFilters.forEach(f => {
              this.workflowFilterIndex[f.workflowId] = f;
            });
          }
        }

        this.refreshColumnOptions();
        this.refreshGrid();

        this.syncDataSetMetaFromForm();
        this.canPublish = this.canTest();
        this.buildAggregateConditionSources();
        this.initAggregateRows();
        this.buildOutputFormulaConditionSources();

        this.form.valueChanges.subscribe(f => {
          this.syncDataSetMetaFromForm();
          this.canPublish = this.canTest();
          this._ref.detectChanges();
        });

        this._ref.detectChanges();
      });
    });
  }

  ngOnDestroy(): void {
    document.removeEventListener('scroll', this.capturedScrollHandler, true);
    document.removeEventListener('wheel', this.capturedScrollHandler, true);
    document.removeEventListener('touchmove', this.capturedScrollHandler, true);
  }

  filterInputSearchField: string;

  removeFilterInputSearchField(filterInputField, filterInputSearchField) {
    filterInputField.searchFields = filterInputField.searchFields.filter(
      sf => sf != filterInputSearchField
    );
  }

  addFilterSearchField(filterInputField) {
    if (filterInputField && this.filterInputSearchField) {
      if (!filterInputField.searchFields) {
        filterInputField.searchFields = [];
      }

      const field = this.dataSet.fields.find(
        f => f.name == this.filterInputSearchField
      );

      if (field) {
        filterInputField.searchFields.push(field);
      }

      this.filterInputSearchField = null;
    }
  }

  buildOutputFormulaConditionSources() {
    let fieldOptions = {};

    this.dataSet.fields.forEach(f => {
      fieldOptions[f.name] = f;
    });

    let fieldNames = this.dataSet.fields.map(f => f.name);

    this.dataSet.fields.forEach(f => {
      if (f.mappings) {
        f.mappings.forEach(m => {
          if (!fieldOptions[m.templateCode]) {
            fieldOptions[m.templateCode] = f;
          }
        });
      }
    });

    const fieldOptKeys = Object.keys(fieldOptions);

    const fieldSources: ConditionSource[] = fieldOptKeys.map(k => {
      return {
        name: k,
        value: k,
        operators: this.buildFieldOperators(fieldOptions[k]),
        possibleValues: this.buildPossibleFieldValues(fieldOptions[k])
      };
    });

    this.outputFormulaConditionSources = fieldSources;
  }

  toggleConditionalOutput(f) {
    if (!f.conditionalOutput) {
      f.outputFormula = null;
    } else {
      f.outputFormula = [new ConditionTarget()];
    }
  }

  createAggRowTypes(rowType: string, aggRow: DataSetAggregateRow) {
    switch (rowType) {
      case AggregatedDataSetRowTypes.groupingRow:
        return new DataSetAggregrateGroupingRow(aggRow);
      case AggregatedDataSetRowTypes.groupingCriteriaRow:
        return new DataSetAggregateGroupedCriteriaRow(aggRow);
    }
  }

  createAggFieldTypes(fieldType: string, aggField: DataSetAggregateField) {
    switch (fieldType) {
      case AggregatedDataSetFieldTypes.calculatedField:
        return new DataSetAggregateCalculatedField(aggField);
      case AggregatedDataSetFieldTypes.groupKeyField:
        return new DataSetAggregateKeyField(aggField);
      case AggregatedDataSetFieldTypes.staticField:
        return new DataSetAggregateStaticField(aggField);
    }
  }

  changeRowType(
    aggDS: AggregatedDataSet,
    aggRow: DataSetAggregateRow,
    aggRowType: string
  ) {
    const newAggRow = this.createRowType(aggRow, aggRowType);

    const aggRowIdx = aggDS.rows.indexOf(aggRow);

    if (aggRowIdx > -1) {
      aggDS.rows[aggRowIdx] = newAggRow;
    }
  }

  createRowType(
    aggRow: DataSetAggregateRow,
    aggRowType: string
  ): DataSetAggregateRow {
    const newAggRow = this.createAggRowTypes(aggRowType, aggRow);

    if (newAggRow) {
      newAggRow.init();
    }

    return newAggRow;
  }

  initAggregateRows() {
    if (this.dataSet.aggregatedDataSets) {
      for (
        let aggIdx = 0;
        aggIdx < this.dataSet.aggregatedDataSets.length;
        aggIdx++
      ) {
        const aggDS = this.dataSet.aggregatedDataSets[aggIdx];

        for (let aggRowIdx = 0; aggRowIdx < aggDS.rows.length; aggRowIdx++) {
          let aggRow = aggDS.rows[aggRowIdx];

          aggRow = this.createRowType(aggRow, aggRow.type);

          for (let fieldIdx = 0; fieldIdx < aggRow.fields.length; fieldIdx++) {
            let aggField = aggRow.fields[fieldIdx];

            aggField = this.createAggFieldTypes(aggField.type, aggField);

            if (aggField) {
              aggField.init();
            }
            aggRow.fields[fieldIdx] = aggField;
          }

          aggDS.rows[aggRowIdx] = aggRow;
        }
      }
    }
  }

  addChildSortOrder(row: DataSetAggregrateGroupingRow) {
    row.sortFields.push(
      new ReportDataSetOrder({ ordinal: row.sortFields.length })
    );
  }

  removeChildSortOrder(row: DataSetAggregrateGroupingRow, fieldOrder: ReportDataSetOrder) {
    const idx = row.sortFields.indexOf(fieldOrder);

    if (idx > -1) {
      row.sortFields.splice(idx, 1);
    }
  }

  childOrderChange(row: DataSetAggregrateGroupingRow) {
    let idx = 0;
    row.sortFields.forEach(fo => {
      fo.ordinal = idx;
      idx++;
    });
  }

  buildSortOrderUI() {
    const existingFieldOrderGroup = this.form.get('fieldOrder') as FormGroup | null;
    const previousOrderValues = this.ds.dataSetConfig.fieldOrder.map((_, idx) =>
      existingFieldOrderGroup?.controls['order' + idx]?.value
    );
    // Added by amisha on 06/29/2026 to preserve saved direction values when rebuilding sort controls for existing datasets.
    // Reason: edit-mode reloads were clearing persisted ascending/descending selections before the next save cycle.
    const shouldResetUnselectedDirections =
      this.showSortingConfiguration && !this.ds?.id;

    this.form.removeControl('fieldOrder');

    this.sortFieldOrder();

    if (shouldResetUnselectedDirections) {
      this.ds.dataSetConfig.fieldOrder.forEach((fieldOrder, idx) => {
        const previousValue = previousOrderValues[idx];
        const wasDirectionExplicitlySelected =
          previousValue === SortDirection.Ascending ||
          previousValue === SortDirection.Descending;

        if (
          fieldOrder &&
          !wasDirectionExplicitlySelected &&
          (
            fieldOrder.direction === null ||
            fieldOrder.direction === undefined ||
            fieldOrder.direction === SortDirection.Ascending ||
            fieldOrder.direction === SortDirection.Descending
          )
        ) {
          fieldOrder.direction = '' as any;
        }
      });
    }

    const fg = new UntypedFormGroup({});

    this.ds.dataSetConfig.fieldOrder.forEach((f, idx) => {
      fg.addControl(
        'field' + idx.toString(),
        new UntypedFormControl(f.fieldName || '', Validators.required)
      );
      fg.addControl(
        'order' + idx.toString(),
        new UntypedFormControl(f.direction || '', Validators.required)
      );
    });

    this.form.addControl('fieldOrder', fg);

    this._ref.detectChanges();
  }

  addFilterInput(field?: DataSetField) {
    if (!field) {
      field = new DataSetField();
    }

    this.filterInputField = field;
    this.filterInputConfig.open();
  }

  editFilterInput(field: DataSetField) {
    this.filterInputField = { ...field };
    this.filterInputConfig.open();
  }

  removeFilterInput(field: DataSetField) {
    this.ds.filterConfig.fields = this.ds.filterConfig.fields.filter(
      f => f.name !== field.name
    );
  }

  updateFilterInput() {
    const f = this.ds.filterConfig.fields.find(
      fld => fld.name === this.filterInputField.name
    );

    if (!f) {
      this.ds.filterConfig.fields.push(this.filterInputField);
    }
    else {
      const idx = this.ds.filterConfig.fields.indexOf(f);

      if (idx > -1) {
        this.ds.filterConfig.fields[idx] = this.filterInputField;
      }
    }

    const dsFld = this.ds.dataSetConfig.fields.find(
      dsF => dsF.name == this.filterInputField.name
    );
    if (dsFld) {
      this.filterInputField.dataType = dsFld.dataType;
    }

    this.filterInputField = null;
  }

  isFiltered(workflowId: string): boolean {
    return (
      this.workflowFilterIndex &&
      this.workflowFilterIndex[workflowId] != null &&
      this.workflowFilterIndex[workflowId].filtersList &&
      this.workflowFilterIndex[workflowId].filtersList.length > 0
    );
  }

  async filterWorkflow(workflowId: string) {
    this.workflowFilterParams = null;
    this.workflowFilters = null;
    this.workflowFilterConfig = null;
    let filter = (this.dataSet.workflowFilters || []).find(
      f => f.workflowId === workflowId
    );
    if (!filter) {
      filter = new WorkflowFilter();
      filter.workflowId = workflowId;
    }

    let entityObs = null;

    if (workflowId != this._context.previousSystemDataWorkflowId) {
      if (workflowId !== this.ALL_WORKFLOWS_ID) {
        entityObs = this._workflowSvc.getDraftWorkflowEntities(workflowId);
      } else {
        entityObs = this._workflowSvc.getDataEntities(null, null, true);
      }
    } else {
      const fields = await this._workflowSvc.getPreviousSystemDataFields(
        this._context.client.id
      );

      entityObs = of(
        fields.map(e => {
          if (e.dataType == ReportDataSetFieldDataType.Date) {
            return new DateDataEntity({
              templateCode: e.name,
              label: e.name
            });
          } else {
            return new FreeFormTextDataEntity({
              templateCode: e.name,
              label: e.name
            });
          }
        })
      );
    }

    entityObs.subscribe(entities => {
      const filterParams: FilterBuilderParam[] = entities.map(e => {
        return {
          name: e.templateCode,
          id: e.templateCode,
          paramId: e.templateCode,
          inputType: DataSet.resolveInputType(e),
          dataEntityTypeCode: e.Type,
          types: DataSet.resolveTypes(e),
          options: (() => {
            const os = DataSet.resolveOptions(e);
            if (os) {
              return os.map(o => {
                return { name: o, value: o };
              });
            } else {
              return null;
            }
          })()
        };
      });

      let filters = [];
      if (filter.filtersList) {
        filters = filter.filtersList
          .map(fl => {
            let value = null;
            let valueString = null;

            if (fl.searchText && fl.searchText.indexOf('{') > -1) {
              value = JSON.parse(fl.searchText);
            } else if (fl.strOperator == 'in' && fl.searchText) {
              value = fl.searchText.split(',');
            } else {
              valueString = fl.searchText;
            }

            if (filterParams.find(fp => fp.name === fl.title)) {
              const p = filterParams.find(fp => fp.name === fl.title);
              return new FilterBuilderFilter({
                param: p,
                value: valueString,
                queryType: fl.strOperator,
                customValue: value,
                inputType: fl.inputType,
                dataEntityTypeCode: fl.dataEntityTypeCode,
                paramId: p.id
              });
            }
          })
          .filter(f => f !== null);
      }

      this.workflowFilterConfig = filter;
      this.workflowFilters = filters.filter(f => f);

      this.workflowFilterParams = filterParams;

    });
  }

  workflowFilterChanges2(e) {
    const filterKeys = Object.keys(e);

    this.workflowFilterConfig.filtersList = [];
    for (let idx = 0; idx < filterKeys.length; idx++) {
      const key = filterKeys[idx];

      e[key].forEach(f => {
        this.workflowFilterConfig.filtersList.push(
          new ItemSearchOptionFieldOption({
            strOperator: f.type,
            title: f.id,
            filterText: f.value,
            searchText: f.value,
            inputType: f.inputType,
            dataEntityTypeCode: f.dataEntityTypeCode
          })
        );
      });
    }
  }

  workflowFilterChanged(e) {
    const filterKeys = Object.keys(e);

    this.workflowFilterConfig.filtersList = [];
    for (let idx = 0; idx < filterKeys.length; idx++) {
      const key = filterKeys[idx];

      this.workflowFilterConfig.filtersList.push(
        new ItemSearchOptionFieldOption({
          strOperator: e[key].type,
          title: e[key].id,
          filterText: e[key].value,
          searchText: e[key].value,
          inputType: e[key].inputType,
          dataEntityTypeCode: e[key].dataEntityTypeCode
        })
      );
    }
  }

  updateWorkflowFilter(workflowFilterConfig) {
    if (!this.dataSet.workflowFilters) {
      this.dataSet.workflowFilters = [];
    }

    const filter = this.dataSet.workflowFilters.find(
      f => f.workflowId == workflowFilterConfig.workflowId
    );

    if (!filter) {
      this.dataSet.workflowFilters.push(workflowFilterConfig);
    }
    this.workflowFilterIndex = {};

    this.dataSet.workflowFilters.forEach(f => {
      this.workflowFilterIndex[f.workflowId] = f;
    });
  }

  canMoveLeft(): boolean {
    if (this.hoverColumn) {
      const hoverColIndex = this.columns.indexOf(this.hoverColumn);
      return hoverColIndex > 1;
    }
    return false;
  }

  canMoveRight(): boolean {
    if (this.hoverColumn) {
      const hoverColIndex = this.columns.indexOf(this.hoverColumn);
      return hoverColIndex < this.columns.length - 2;
    }
    return false;
  }

  hideColumnActions() {
    this.columnHideId = setTimeout(() => {
      if (!this.hoveringOnAction) {
        this.hoverLeft = 0;
        this.hoverColumn = null;
      }
    }, 1000);
  }

  columnHover(column: NgxTableColumn, e) {
    if (this.columnHideId) {
      clearTimeout(this.columnHideId);
    }
    if (this.hoverLeft === 0 || this.hoverColumn !== column) {
      this.hoverLeft =
        e.clientX - this.columnActions.nativeElement.offsetWidth * 2;
    }
    this.hoverColumn = column;
  }

  moveFieldLeft(column: NgxTableColumn) {
    const idx = this.columns.indexOf(column);

    if (idx > -1 && idx > 1) {
      this.moveFieldToIndex(column, idx - 1);
    }
  }

  moveFieldToIndex(column: NgxTableColumn, targetColumnIdx: number) {
    // columns list has a workflowId column at beginning and add column at the end
    // fields list does not have the workflowId column or the add column so we have to offset field indexes from targetColumn Index

    const idx = this.columns.indexOf(column);

    // we don't allow the first column to be moved or the last column to be moved
    if (idx > 0 && idx < this.columns.length) {
      const fieldIdx = idx - 1; // workflowId column isn't in fields list
      const targetFieldIdx = targetColumnIdx - 1;

      if (targetFieldIdx >= 0 && targetFieldIdx < this.dataSet.fields.length) {
        const field = this.dataSet.fields[fieldIdx];
        this.dataSet.fields.splice(fieldIdx, 1); // remove the field from the old index
        this.dataSet.fields.splice(targetFieldIdx, 0, field); // insert the field into the new index
        this.refreshGrid();
      }
    }
  }

  moveFieldRight(column: NgxTableColumn) {
    const idx = this.columns.indexOf(column);

    if (idx > -1 && idx < this.dataSet.fields.length) {
      this.moveFieldToIndex(column, idx + 1);
    }
  }

  openFieldSettings(field: DataSetField) {
    this.actionField = field;

    if (this.actionField.outputFormula) {
      this.actionField.conditionalOutput = true;
    } else {
      this.actionField.conditionalOutput = false;
    }

    this.fieldSettingsTitle =
      this.actionField && this.actionField.name !== ''
        ? this.actionField.name
        : 'New';

    this.fieldSettings.open();
  }

  configureField(column: NgxTableColumn) {
    const field = this.dataSet.fields.find(f => f.name === column.prop);

    this.openFieldSettings({ ...field });
  }

  removeSortOrder(fieldOrder: ReportDataSetOrder) {
    const idx = this.dataSet.fieldOrder.indexOf(fieldOrder);

    if (idx > -1) {
      this.dataSet.fieldOrder.splice(idx, 1);
      this.buildSortOrderUI();
    }
  }

  orderChange() {
    let idx = 0;
    this.dataSet.fieldOrder.forEach(fo => {
      fo.ordinal = idx;
      idx++;
    });
    this.buildSortOrderUI();
  }

  sortFieldOrder() {
    this.dataSet.fieldOrder.sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
  }

  addSortOrder() {
    (<UntypedFormGroup>this.form.controls['fieldOrder']).addControl(
      'field' + this.dataSet.fieldOrder.length.toString(),
      new UntypedFormControl('', Validators.required)
    );
    (<UntypedFormGroup>this.form.controls['fieldOrder']).addControl(
      'order' + this.dataSet.fieldOrder.length.toString(),
      new UntypedFormControl('', Validators.required)
    );

    this.dataSet.fieldOrder.push(
      new ReportDataSetOrder({ ordinal: this.dataSet.fieldOrder.length, direction: '' as any })
    );

    this.buildSortOrderUI();
  }

  itemSelected(e) {
    this.activeMapping.templateCode = e.item;
    if (this.mappingForm.controls['columnEntity']) {
      this.mappingForm.controls['columnEntity'].setValue(e.item);
    }
  }

  searchFields(searchTerm): Observable<string[]> {
    if (this.previousSystemFields) {
      const fpf = this.previousSystemFields
        .filter(f => f.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1)
        .map(f => f.name);
      return of(fpf);
    }
    return of();
  }

  searchPreviousSystemFields = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(
      debounceTime(200),
      distinctUntilChanged()
    );

    const inputFocus$ = this.focus$;

    return merge(debouncedText$, inputFocus$).pipe(
      tap(() => (this.searching = true)),
      switchMap(term => {
        let searchTerm = '';
        searchTerm = term;

        return this.searchFields(searchTerm);
      }),
      tap(() => (this.searching = false))
    );
  };

  openMapping() {
    if (
      this.activeMapping.workflowId ==
      this._context.previousSystemDataWorkflowId
    ) {
      this._workflowSvc
        .getPreviousSystemDataFields(this._context.client.id)
        .then(result => {
          this.previousSystemFields = result;
        });
    }
  }

  // openFilterSettings() {
  //   if (
  //     this.workflowFilterConfig &&
  //     this.workflowFilterConfig.workflowId ==
  //     this._context.previousSystemDataWorkflowId
  //   ) {
  //     this._workflowSvc
  //       .getPreviousSystemDataFields(this._context.client.id)
  //       .then(result => {
  //         this.previousSystemFields = result;
  //       });
  //   }
  // }

  updateWorkflow(row) {
    const rowIdx = this.rows.indexOf(row);

    if (rowIdx > -1) {
      if (rowIdx < this.dataSet.workflowIds.length) {
        const workflowId = (<UntypedFormGroup>this.form.controls['workflows'])
          .controls[rowIdx].value;
        row['workflowId'] = workflowId;
        this.dataSet.workflowIds[rowIdx] = workflowId;
        if (
          workflowId == this._context.previousSystemDataWorkflowId &&
          this._context.client
        ) {
          // call this here so those are loaded and ready for mappings and filtering
          this._workflowSvc.getPreviousSystemDataFields(
            this._context.client.id
          );
        }
        if (
          !this.workflowEntities[workflowId] &&
          (this.dataSet.workflowIds[rowIdx] || '') !==
          this._context.previousSystemDataWorkflowId
        ) {
          this._workflowSvc
            .getWorkflowEntities(this.dataSet.workflowIds[rowIdx])
            .subscribe(entities => {
              this.workflowEntities[workflowId] = entities;
            });
        }
        if (
          this.dataSet.workflowFilters &&
          rowIdx < this.dataSet.workflowFilters.length
        ) {
          const wf = this.dataSet.workflowFilters[rowIdx];

          if (wf && !wf.filtersList) {
            wf.filtersList = [];
          }
        }
      }
    }
  }

  cancelColumn() {
    this.actionField = null;
  }
  updateColumn() {
    const exColumn = this.dataSet.fields.find(f => f.id == this.actionField.id);

    if (!exColumn) {
      // check to see if a column with the same name exists
      const exColumnName = this.dataSet.fields.find(
        f => f.name.toLowerCase() == this.actionField.name.toLowerCase()
      );

      if (exColumnName) {
        this._toastr.error(
          `There is already a existing column with name ${this.actionField.name}.`
        );
        return;
      }

      this.dataSet.fields.push(this.actionField);

      // If sort configuration is hidden and this is the first field, add/update it in sort order
      if (!this.showSortingConfiguration && this.dataSet.fields.length === 1) {
        if (this.dataSet.fieldOrder.length > 0 && !this.dataSet.fieldOrder[0].fieldName) {
          // Update the first existing fieldOrder object
          this.dataSet.fieldOrder[0].fieldName = this.actionField.name;
          this.dataSet.fieldOrder[0].direction = SortDirection.Ascending;
        } else if (this.dataSet.fieldOrder.length === 0) {
          // Add a new fieldOrder object
          const sortOrder = new ReportDataSetOrder({
            ordinal: 0,
            fieldName: this.actionField.name,
            direction: SortDirection.Ascending
          });
          this.dataSet.fieldOrder.push(sortOrder);
        }
        // Rebuild the form controls to reflect the updated fieldOrder
        this.buildSortOrderUI();
      }
    } else {
      const idx = this.dataSet.fields.indexOf(exColumn);

      if (idx > -1) {
        this.dataSet.fields[idx] = this.actionField;
      }
    }

    this.refreshColumnOptions();
    this.refreshGrid();
    this.actionField = null;
  }

  addMapping(row, column) {
    const workflowId: string = row['workflowId'];

    if (this.workflowIdx && workflowId && this.workflowIdx[workflowId]) {
      // clear cached entities so that if the workflow has changed we get the latest
      if (this.lastMappingWorkflowId !== workflowId) {
        this._workflowSvc.clearCachedEntities();
      }
      const mapping = new ReportDataSetFieldMapping();
      mapping.workflowId = workflowId;
      mapping.columnIndex = this.dsGrid.columns.indexOf(column);
      this.activeMapping = mapping;
      this.lastMappingWorkflowId = workflowId;
      this.mappingForm.reset();
      this.mappingConfig.open();
    }
    else {
      this.selectWorkflowWarning.open();
    }
  }

  cancelMapping() {
    this.activeMapping = null;
  }
  updateMapping() {
    const column = this.dsGrid.columns[this.activeMapping.columnIndex];

    const dsField = this.dataSet.fields.find(f => f.name === column.prop);

    if (dsField) {
      let mappings = dsField.mappings;

      if (!mappings) {
        mappings = [];
      }

      const mapping = mappings.find(
        m =>
          m.workflowId === this.activeMapping.workflowId &&
          m.templateCode === this.activeMapping.templateCode
      );

      if (!mapping) {
        mappings.push(this.activeMapping);

        this.refreshGrid();
      }
    }

    this.activeMapping = null;
  }

  addColumn() {
    const field = new DataSetField();

    field.name = '';

    this.openFieldSettings(field);
  }

  refreshGrid() {
    const columns = this.buildColumns();
    const rows = this.buildRows();

    this.columns = columns;
    this.rows = rows;
  }

  addWorkflow() {
    (<UntypedFormGroup>this.form.controls['workflows']).addControl(
      this.dataSet.workflowIds.length.toString(),
      new UntypedFormControl('', Validators.required)
    );
    this.dataSet.workflowIds.push('');
    this.refreshGrid();
  }

  private syncFieldOrderWithFields() {
    if (!this.dataSet) {
      return;
    }

    const fieldNames = new Set(
      (this.dataSet.fields || []).map(f => f.name)
    );

    this.dataSet.fieldOrder = (this.dataSet.fieldOrder || [])
      .filter(fo => fo && (!fo.fieldName || fieldNames.has(fo.fieldName)))
      .map((fo, idx) => ({
        ...fo,
        ordinal: idx
      }));

    if (this.dataSet.fieldOrder.length === 0) {
      this.dataSet.fieldOrder.push(
        new ReportDataSetOrder({
          ordinal: 0,
          fieldName: ''
        })
      );
    }
  }

  private syncFilterFieldsWithColumns() {
    if (!this.ds?.filterConfig) {
      return;
    }

    const fieldNames = new Set((this.dataSet?.fields || []).map(f => f.name));
    this.ds.filterConfig.fields = (this.ds.filterConfig.fields || []).filter(
      field => field?.name && fieldNames.has(field.name)
    );
  }

  private normalizeFilterField(filter: any) {
    const dsField = (this.dataSet?.fields || []).find(
      field => field.name === filter?.name
    );

    return {
      ...filter,
      dataType: dsField?.dataType ?? filter?.dataType,
      requireInput: filter?.requireInput ?? filter?.required ?? false,
      searchFields: filter?.searchFields || [],
      mappings: filter?.mappings || [],
      showListForSelection: filter?.showListForSelection ?? false,
      allowListSelection: filter?.allowListSelection ?? false,
      isParcelNumber: filter?.isParcelNumber ?? false,
      isPermitNumber: filter?.isPermitNumber ?? false
    };
  }

  private refreshColumnOptions() {
    this.columnOptions = (this.dataSet?.fields || [])
      .filter(field => !!field?.name)
      .map(field => ({
        label: field.name,
        value: field.name
      }));
  }

  onDatasetChange(data: any) {


    this.dataSet.fields = data.fields;
    this.dataSet.workflowIds = data.workflowIds;
    this.dataSet.workflowFilters = data.workflowFilters;
    this.refreshColumnOptions();
    this.syncFilterFieldsWithColumns();
    this.syncFieldOrderWithFields();
    this.buildSortOrderUI();
    this.refreshGrid();

  }

  openColumnSettingsModal(
    request: string | null | { workflowId: string | null; field?: any | null }
  ) {
    const columnRequest =
      typeof request === 'object' && request !== null ? request : null;

    this.selectedColumnSettingsWorkflowId = columnRequest
      ? columnRequest.workflowId
      : (request as string | null);
    this.selectedColumnSettingsField = columnRequest?.field || null;
    this.columnSettingsTopOffsetPx = 0;
    this.isColumnSettingsOpen = true;
    this._ref.detectChanges();

    const scrollModalIntoView = () => {
      const overlayZone = this.datasetOverlayZone?.nativeElement;
      const modal = overlayZone?.querySelector(
        'wm-column-settings .wm-overlay-content'
      ) as HTMLElement | null;
      const backdrop = overlayZone?.querySelector(
        'wm-column-settings .wm-overlay-backdrop'
      ) as HTMLElement | null;

      if (!modal) {
        return false;
      }

      // Added by Amisha on 09/25/2026. Reason: reset the modal viewport and let
      // every nested reports scroller reveal its header at all screen sizes.
      backdrop?.scrollTo({ top: 0, behavior: 'auto' });
      modal.scrollIntoView({
        block: 'start',
        inline: 'nearest',
        behavior: 'auto'
      });

      return true;
    };

    let attempts = 0;
    const tryScroll = () => {
      attempts++;
      const didScroll = scrollModalIntoView();

      if (!didScroll && attempts < 6) {
        requestAnimationFrame(tryScroll);
      }
    };

    requestAnimationFrame(tryScroll);
  }

  closeColumnSettingsModal() {
    this.isColumnSettingsOpen = false;
    this.selectedColumnSettingsWorkflowId = null;
    this.selectedColumnSettingsField = null;
    this.columnSettingsTopOffsetPx = 0;
  }

  handleColumnSettingsSave(field: any) {
    this.datasetAddWorkflows?.handleColumnSave(field);
    this.refreshColumnOptions();
    this.closeColumnSettingsModal();
  }

  getFieldLabel(fieldName: string) {

    const field = this.dataSet.fields.find(f => f.name === fieldName);

    return field ? field.name : fieldName;

  }
  removeWorkflow(workflowId: string) {
    const newIds = this.dataSet.workflowIds.filter(wid => wid !== workflowId);

    this.dataSet.fields.forEach(f => {
      f.mappings = f.mappings.filter(m => m.workflowId !== workflowId);
    });

    this.dataSet.workflowIds = newIds;

    if (this.dataSet.workflowFilters) {
      this.dataSet.workflowFilters = this.dataSet.workflowFilters.filter(
        f => f.workflowId !== workflowId
      );
    }

    this.refreshGrid();
  }

  canRemoveColumn(column: NgxTableColumn): boolean {
    if (column) {
      const field = this.dataSet.fields.find(f => f.name === column.prop);
      return field && !field.isStatic;
    }
    return false;
  }

  removeColumn(column: NgxTableColumn) {
    this.hoveringOnAction = true;

    // Check if field is static and prevent removal
    const field = this.dataSet.fields.find(f => f.name === column.prop);
    if (field && field.isStatic) {
      return;
    }

    const fieldOrderProp = this.dataSet.fieldOrder.find(
      fo => fo.fieldName === column.prop
    );

    // if(fieldOrderProp) {
    //   fieldOrderProp.fieldName = null;
    // }

    this.dataSet.fields = this.dataSet.fields.filter(
      f => f.name !== column.prop
    );

    // remove column from input filters if exists
    this.ds.filterConfig.fields = this.ds.filterConfig.fields.filter(
      f => f.name !== column.prop
    );

    // flip the allow filters toggle to false if there aren't any fields in the dataset
    if (this.dataSet.fields.length === 0) {
      this.allowFiltering = false;
    }

    this.refreshGrid();
  }

  allowFilteringChanged(e) {
    this.allowFiltering = e;

    if (!e) {
      this.ds.filterConfig.fields = [];
    }
  }

  removeMapping(column: NgxTableColumn, mappings: any[], idx) {
    const field = this.dataSet.fields.find(f => f.name === column.prop);

    if (field) {
      const mappingToRemove = mappings[idx];
      const mapIdx = field.mappings.indexOf(mappingToRemove);
      field.mappings.splice(mapIdx, 1);
    }
    this.refreshGrid();
  }

  canTest() {
    const dataSetName = (this.form?.controls['dataSetName']?.value || this.ds?.name || '').trim();
    return (
      this.dataSet &&
      this.dataSet.fields.length !== 0 && // no fields defined
      this.ds &&
      dataSetName !== '' && // name defined
      !this.dataSet.fieldOrder.some(fo => (fo.fieldName || '') === '')
    );
  }

  columnsReordered(e: { column: any; newValue: number; prevValue: number }) {
    this.moveFieldToIndex(e.column, e.newValue);
  }

  buildColumns(): NgxTableColumn[] {
    return [
      {
        prop: 'workflowId',
        name: 'Workflow',
        cellTemplate: this.workflowColumnTmpl,
        canAutoResize: true,
        draggable: false,
        sortable: false,
        frozenLeft: true,
        width: 250
      },
      ...this.dataSet.fields.map(f => {
        return {
          prop: f.name,
          name: f.resultHeader ? `${f.resultHeader} (${f.name})` : f.name,
          cellTemplate: this.columnTmpl,
          headerTemplate: this.columnHeaderTmpl,
          sortable: false,
          minWidth: 150,
          resizeable: false
        };
      }),
      {
        headerTemplate: this.columnHeaderTmpl,
        canAutoResize: false,
        resizeable: false,
        frozenRight: true,
        width: 150,
        sortable: false
      }
    ];
  }

  buildRows() {
    // build a row for each workflow and a column in that row for each column in the dataset
    const rows = [];

    this.dataSet.workflowIds.forEach(w => {
      const row = {
        workflowId: w
      };

      this.dataSet.fields.forEach(f => {
        row[f.name] = f.mappings.filter(m => m.workflowId === w);
      });

      rows.push(row);
    });

    // this needs to be here so that the All Workflows shows up and the horizontal scrollbar displays if necessary
    if (rows.length === 0) {
      rows.push({
        empty: true
      });
    }

    return rows;
  }

  private validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  private syncDataSetMetaFromForm() {
    if (!this.ds || !this.form) {
      return;
    }

    const dataSetName = (this.form.controls['dataSetName']?.value || '').trim();
    const dataSetDesc = this.form.controls['dataSetDesc']?.value || '';
    const dataSetType =
      this.form.controls['dataSetType']?.value ||
      this.ds.dataSetConfig?.type ||
      'workflow-application-dataset';
    const dataSetOutput =
      this.form.controls['dataSetOutput']?.value ??
      this.ds.dataSetConfig?.outputDataSet ??
      '';

    this.ds.name = dataSetName;
    this.ds.description = dataSetDesc;

    if (this.ds.dataSetConfig) {
      this.ds.dataSetConfig.type = dataSetType;
      this.ds.dataSetConfig.outputDataSet = dataSetOutput;
    }

    this.normalizeFieldOrderForRequest();
  }

  private normalizeFieldOrderForRequest() {
    if (!this.dataSet?.fieldOrder) {
      return;
    }

    this.dataSet.fieldOrder = this.dataSet.fieldOrder.map((fieldOrder, index) => {
      const normalizedDirection =
        Number(fieldOrder.direction) === SortDirection.Descending
          ? SortDirection.Descending
          : SortDirection.Ascending;

      return new ReportDataSetOrder({
        ...fieldOrder,
        ordinal: index,
        direction: normalizedDirection
      });
    });
  }

  private buildSerializedDataSetConfig(): any {
    const workflowFilters = (this.dataSet?.workflowIds || [])
      .map((workflowId, index) => {
        if (!workflowId) {
          return null;
        }

        const filter =
          (this.dataSet?.workflowFilters || [])[index] || {
            workflowId,
            filtersList: []
          };

        return {
          ...filter,
          workflowId,
          filtersList: (filter.filtersList || [])
            .filter(filterItem => {
              const hasValue =
                (filterItem?.filterText || '') !== '' ||
                (filterItem?.searchText || '') !== '' ||
                (filterItem?.strOperator || '') === 'exists' ||
                (filterItem?.strOperator || '') === 'not exists';

              return hasValue;
            })
            .map(filterItem => ({
              ...filterItem
            }))
        };
      })
      .filter(filter => !!filter && (filter.filtersList || []).length > 0);

    return {
      ...this.dataSet,
      fieldOrder: (this.dataSet?.fieldOrder || []).map(fieldOrder => ({
        ...fieldOrder,
        direction:
          fieldOrder.direction !== null && fieldOrder.direction !== undefined
            ? String(fieldOrder.direction)
            : ''
      })),
      workflowFilters
    };
  }

  private buildSerializedDataSetPayload(): any {
    return {
      ...this.ds,
      dataSetConfig: this.buildSerializedDataSetConfig()
    };
  }
  private buildTestDataSetConfig(): any {
    const serializedDataSetConfig = this.buildSerializedDataSetConfig();

    return {
      ...this.dataSet,
      fieldOrder: serializedDataSetConfig.fieldOrder,
      workflowFilters: serializedDataSetConfig.workflowFilters
    };
  }
  private buildTestFilterConfig(): any {
    return this.ds?.filterConfig || { fields: [], staticFilterInput: [] };
  }

  saveDataSet() {
    this.syncDataSetMetaFromForm();
    this.syncFilterFieldsWithColumns();

    if (this.canTest() && this.form.valid) {
      // Apply static filters if provided - convert ItemSearchOptionField[] to ItemSearchOptionFieldOption[]
      if (this.staticFilters && this.staticFilters.length > 0) {
        // Flatten the ItemSearchOptionField structure to ItemSearchOptionFieldOption array for backend
        const flattenedFilters: ItemSearchOptionFieldOption[] = [];
        this.staticFilters.forEach(field => {
          if (field.options && field.options.length > 0) {
            field.options.forEach(option => {
              flattenedFilters.push(option);
            });
          }
        });
        this.ds.filterConfig.staticFilterInput = flattenedFilters;
      }

      this._workflowSvc.saveDataSet(this.buildSerializedDataSetPayload()).subscribe(ds => {
        this.ds = ds;
        this.dataSet = ds.dataSetConfig;
        this.buildAggregateConditionSources();
        this.initAggregateRows();
        this.buildOutputFormulaConditionSources();
        this.openSaveSuccessModal();
        // Emit the saved dataset ID for parent components
        this.dataSetSaved.emit(ds.id);
      });
    } else {
      this.validateAllFormFields(this.form);
    }
  }

  navigateToExistingDS(id: string) {
    this._router.navigate([
      '/admin/jurisdiction',
      this._context.client.id,
      'reports',
      'data-set',
      id
    ]);
  }

  publishDataSet() {
    this.syncDataSetMetaFromForm();

    if (this.canTest()) {
      this._workflowSvc.saveDataSet(this.buildSerializedDataSetPayload()).subscribe(resultDS => {
        this._workflowSvc.publishDataSet(resultDS.id).subscribe(() => {
          this.ds = resultDS;
          this.dataSet = resultDS.dataSetConfig;
          this.openSaveSuccessModal(
            'Data Set Published',
            'Your data set has been published successfully.'
          );
        });
      });
    }
  }

  getRowFieldsByType(row: DataSetAggregateRow, type: string) {
    return row.fields.filter(f => f.type == type);
  }
  addAggregatedDataSet() {
    if (!this.dataSet.aggregatedDataSets) {
      this.dataSet.aggregatedDataSets = [];
    }

    this.dataSet.aggregatedDataSets.push({
      name: '',
      rows: [],
      fieldOrder: []
    });

    this.aggSets.activeId = 'New';
  }

  removeAggregatedDataSet(aggDs: AggregatedDataSet) {
    const idx = this.dataSet.aggregatedDataSets.indexOf(aggDs);

    if (idx > -1) {
      this.dataSet.aggregatedDataSets.splice(idx, 1);
    }
  }

  addAggregateDataSetRow(aggDs: AggregatedDataSet) {
    if (!aggDs.rows) {
      aggDs.rows = [];
    }

    aggDs.rows.push({
      fields: [],
      type: ''
    });
  }

  removeAggregateDataSetRow(
    aggDs: AggregatedDataSet,
    aggRow: DataSetAggregateRow
  ) {
    const idx = aggDs.rows.indexOf(aggRow);

    if (idx > -1) {
      aggDs.rows.splice(idx, 1);
    }
  }

  buildFieldOperators(field: DataSetField): ConditionOperator[] {
    const ops: ConditionOperator[] = [
      OperatorTypes.IS,
      OperatorTypes.EXISTS,
      OperatorTypes.NOT_EXISTS,
      OperatorTypes.IS_NOT,
      OperatorTypes.CONTAINS,
      OperatorTypes.DOES_NOT_CONTAIN
    ];

    if (field.dataType == ReportDataSetFieldDataType.Date) {
      [OperatorTypes.RANGE].forEach(o => {
        ops.push(o);
      });
    }

    if (field.dataType == ReportDataSetFieldDataType.String) {
      ops.push(OperatorTypes.DOES_NOT_CONTAIN);
    }

    return ops;
  }

  buildPossibleFieldValues(field: DataSetField): ConditionValue[] {
    if (field.dataType == ReportDataSetFieldDataType.Date) {
      const dateInputs = this.ds.filterConfig.fields.filter(
        f => f.dataType == ReportDataSetFieldDataType.Date
      );

      return dateInputs.map(di => {
        return {
          name: `input:${di.name}`,
          value: `input:${di.name}`
        };
      });
    }

    return null;
  }

  // Builds the list of condition sources based on the data set configuration
  buildAggregateConditionSources() {
    const fieldSources: ConditionSource[] = this.dataSet.fields.map(f => {
      return {
        name: f.name,
        value: f.name, //f.resultHeader,
        operators: this.buildFieldOperators(f),
        possibleValues: this.buildPossibleFieldValues(f)
      };
    });

    this.conditionSources = fieldSources;
  }

  addGroupingField(aggRow: DataSetAggregrateGroupingRow) {
    if (!aggRow.groupByFields) {
      aggRow.groupByFields = [];
    }
    aggRow.groupByFields.push(this.newGroupingField);
  }

  removeGroupingField(aggRow: DataSetAggregrateGroupingRow, field: string) {
    const idx = aggRow.groupByFields.indexOf(field);

    if (idx > -1) {
      aggRow.groupByFields.splice(idx, 1);
    }
  }

  addAggregateCalculatedField(aggRow: DataSetAggregateRow) {
    this.addAggregateRowField(aggRow, new DataSetAggregateCalculatedField());
  }

  addAggregateKeyField(aggRow: DataSetAggregateRow) {
    this.addAggregateRowField(aggRow, new DataSetAggregateKeyField());
  }

  addAggregateStaticField(aggRow: DataSetAggregateRow) {
    this.addAggregateRowField(aggRow, new DataSetAggregateStaticField());
  }

  addAggregateRowField(
    aggRow: DataSetAggregateRow,
    field: DataSetAggregateField
  ) {
    if (!aggRow.fields) {
      aggRow.fields = [];
    }

    aggRow.fields.push(field);
  }

  removeAggregateRowField(
    aggRow: DataSetAggregateRow,
    aggField: DataSetAggregateField
  ) {
    const idx = aggRow.fields.indexOf(aggField);

    if (idx > -1) {
      aggRow.fields.splice(idx, 1);
    }
  }

  private createResultTableColumns(
    columns: Array<{ prop: string; name: string }>
  ): CommonTableColumn[] {
    return columns.map(column => ({
      key: column.prop,
      label: column.name,
      headerType: 'text',
      cellType: 'text'
    }));
  }

  closeTestResults() {
    this.resultColumns = null;
    this.resultRows = null;
    this.aggregatedResultRows = null;
    this.aggregatedResultColumns = null;
  }

  testDataSet() {
    this.syncDataSetMetaFromForm();
    this.syncFilterFieldsWithColumns();

    let inputValues: ItemSearchOptionFieldOption[] = [];

    if (this.filters) {
      const filterKeys = Object.keys(this.filters);

      const mappedFilters = filterKeys.flatMap(f => {
        return this.filters[f].map(filter => {
          return new ItemSearchOptionFieldOption({
            title: filter.id,
            strOperator: filter.type,
            searchText: filter.value,
            filterText: filter.value,
            inputType: filter.inputType
          });
        })
      });

      inputValues = inputValues.concat(mappedFilters);
    }

    // Ensure filterConfig exists
    if (!this.ds.filterConfig) {
      this.ds.filterConfig = { fields: [], staticFilterInput: [] };
    }

    // Add static filters to the filterConfig.staticFilterInput instead of inputValues
    if (this.staticFilters && this.staticFilters.length > 0) {
      const staticFilterValues = this.staticFilters.flatMap(field => {
        return field.options || [];
      });
      // Temporarily add to filterConfig for testing
      this.ds.filterConfig.staticFilterInput = staticFilterValues;
    }

    const request = {
      customReport: {
        dataSetConfig: this.buildTestDataSetConfig(),
        filterConfig: this.buildTestFilterConfig()
      },
      filterInput: {
        inputValues: inputValues,
        maxRows: 20
      }
    };

    this.executingTest = true;
    this.resultColumns = null;

    this.resultRows = null;
    this.aggregatedResultRows = null;
    this.aggregatedResultColumns = null;
    this._reportSvc.testDataSet(request).subscribe(
      results => {
        const resultColumns = this.dataSet.fields.map(f => {
          return {
            prop: (f.resultHeader || f.name).toLowerCase(),
            name: f.resultHeader || f.name
          };
        });

        const resultRows = [];

        for (let idx = 0; idx < results.rows.length; idx++) {
          const r = results.rows[idx];
          const result = {};

          result['id'] = r.id;

          Object.keys(r.values).forEach(k => {
            const newKey = k.toLowerCase();
            result[newKey] = r.values[k];
          });

          resultRows.push(result);
        }

        const aggregatedResultRows = {};

        // translate aggregated results
        if (results.aggregatedResults) {
          const keys = Object.keys(results.aggregatedResults);
          this.aggregatedResultColumns = {};
          keys.forEach(key => {
            const aggDS = (this.dataSet.aggregatedDataSets || []).find(
              ads => ads.name.toLowerCase() == key.toLowerCase()
            );
            let aggColumns = [];
            if (aggDS) {
              aggColumns = aggDS.rows[0].fields.map(f => {
                return {
                  prop: f.name.toLowerCase(),
                  name: f.headerText || f.name
                };
              });
            } else {
              aggColumns = Object.keys(
                results.aggregatedResults[key][0].values
              ).map(k => {
                return {
                  prop: k.toLowerCase(),
                  name: k
                };
              });
            }

            this.aggregatedResultColumns[key] =
              this.createResultTableColumns(aggColumns);

            const aggResultRows = [];
            const aggRows = results.aggregatedResults[key];

            if (aggRows) {
              for (let aggIdx = 0; aggIdx < aggRows.length; aggIdx++) {
                const r = aggRows[aggIdx];
                const aggResult = {};

                aggResult['id'] = r.id;

                Object.keys(r.values).forEach(k => {
                  const newKey = k.toLowerCase();
                  aggResult[newKey] = r.values[k];
                });

                aggResultRows.push(aggResult);
              }

              aggregatedResultRows[key] = aggResultRows;
            }
          });
        }

        this.aggregatedResultRows = aggregatedResultRows;

        this.executingTest = false;

        this.resultColumns = this.createResultTableColumns(resultColumns);

        this.resultRows = resultRows;
      },
      e => {
        this.executingTest = false;
        if (e instanceof TimeoutError) {
          this._toastr.error('Test took too long');
        } else {
          const errorMsg = 'Something went wrong while adding the new dataset. Please check your input and try again.';
          this._toastr.error(errorMsg || e.error.exceptionMessage);

        }
      }
    );
  }

  getThenLabel = (target: ConditionTarget): string => {
    if (target) {
      return target.value || null;
    }

    return null;
  };

  conditionsChanged(e) {
    this.actionField.outputFormula = e;
  }

  // added by ketan 09-03-2026
  keyBoardDropDownIcon = svgs.keyboardArrowDownIcon.name
  selectOrderBy(field: string, idx: number) {

    this.dataSet.fieldOrder[idx].fieldName = field;

    (this.form.get('fieldOrder') as FormGroup)
      .controls['field' + idx]
      .setValue(field);
  }

selectDirection(value: number, idx: number) {
  const direction = value as SortDirection;

  this.dataSet.fieldOrder[idx].direction = direction;

  (this.form.get('fieldOrder') as FormGroup)
    .controls['order' + idx]
    .setValue(direction);
}
  sortingConfigurationDeleteModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Remove Sorting Column',
    modalSubDescp: 'Are you sure you want to remove this Sorting Column?',
    yesNoBtn: true,
    okBtn: false,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'default'
  };
  sortingConfigurationDeleteTarget?: ReportDataSetOrder;
  onSortingConfigurationDeleteClick = (template: TemplateRef<any>, fieldOrder: ReportDataSetOrder) => {
    return {
      text: template,
      onClick: () => {
        this.sortingConfigurationDeleteTarget = fieldOrder;
        this.sortingConfigurationDeleteModalData = {
          ...this.sortingConfigurationDeleteModalData,
          open: true
        };
      }
    }
  }

  handleSortingConfigurationDeleteModalAccepted(fieldOrder: ReportDataSetOrder) {
    const idx = this.dataSet.fieldOrder.indexOf(fieldOrder);
    if (idx > -1) {
      this.dataSet.fieldOrder.splice(idx, 1);
      this.buildSortOrderUI();
    }
  }

  handleSortingConfigurationDeleteModalRejected() {
  }
  saveSuccessModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Data Set Saved',
    modalSubDescp: 'Your data set has been saved successfully.',
    yesNoBtn: false,
    okBtn: true,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'success'
  };

  openSaveSuccessModal(
    modalDescp = 'Data Set Saved',
    modalSubDescp = 'Your data set has been saved successfully.'
  ) {
    this.saveSuccessModalData = {
      ...this.saveSuccessModalData,
      modalDescp,
      modalSubDescp,
      open: true
    };
  }

  handleSaveSuccessModalOk() {
    this.saveSuccessModalData = {
      ...this.saveSuccessModalData,
      open: false
    };
  }
  // ended by ketan 09-03-2026
  @Output() workflowSelected = new EventEmitter<string>();


  onWorkflowSelected(workflowId: string) {
      setTimeout(() => {
        this.filterWorkflow(workflowId);
  this.buildOutputFormulaConditionSources()
      });

    }
    @ViewChild('publishModal', { static: false }) publishModal: any;

    publishDataSetModalData: CommonConfirmationModalData = {
      open: false,
      modalDescp: 'Publish Data Set Confirmation',
      modalSubDescp: 'Are you sure you want to publish the changes to this Data Set?',
      yesNoBtn: true,
      inTime: 300,
      outTime: 200,

    };

    onOpenPublishData() {
      this.publishDataSetModalData = {
        ...this.publishDataSetModalData,
        open: true
      };
    }
    onClosePublishData = () => {
      this.publishDataSetModalData = {
        ...this.publishDataSetModalData,
        open: false
      };
    };
    onPublishDataSet() {
      this.publishDataSetModalData = {
        ...this.publishDataSetModalData,
        open: false
      };


    }

}
